<template>
    <div
        v-if="banner && isBannerOpen && !hasBannerBeenViewed(bannerId)"
        class="banner vm"
    >
        <IconCross @click.prevent="closeBanner(bannerId)" />
        <p v-html="banner"></p>
    </div>
</template>

<script>
import { hasBannerBeenViewed, setBannerAsViewed } from '@/helpers'
import IconCross from '@/components/Icons/Cross.vue'

export default {
  name: 'BannerText',
    components: {
        IconCross
    },
    props: {
        banner: String
    },
    data() {
        return {
            bannerId: 'meh',
            isBannerOpen: true,
            hasBannerBeenViewed
        }
    },
    methods: {
        closeBanner(id) {
            this.isBannerOpen = false
            setBannerAsViewed(id)
        }
    }
}
</script>

<style lang="scss">
.banner {
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    display: flex;
    font-size: 14px;
    text-align: center;
    height: $banner-height;
    box-sizing: border-box;
    padding: 5px 40px 5px 10px;
    background-color: #292929;
    color: #fff;

    .close {
        font-size: 22px;
        color: #fff;
    }
}

@media (min-width: $mq-small) {
    .banner {
        font-size: 16px;
        padding: 5px 10px 5px 10px;
    }
}
</style>
